import { environment } from '../../../environments/environment';
import type { MediaSourceBases, MediaSourceType } from './media-url.utils';
import { resolveMediaSource } from './media-url.utils';

export const APP_MEDIA_SOURCE_BASES: Readonly<MediaSourceBases> = {
  image: environment.assets,
  video: environment.video,
};

export function resolveAppMediaSource(
  source: string | null | undefined,
  mediaType: MediaSourceType
): string {
  return resolveMediaSource(source, mediaType, APP_MEDIA_SOURCE_BASES);
}
